import React from 'react';

import Const from '../../util/Constants';

import FieldText from '../common/FieldText';
import FieldTextArea from '../common/FieldTextArea';
import FieldNumber from '../common/FieldNumber';
import FieldDecimal from '../common/FieldDecimal';
import FieldDate from '../common/FieldDate';
import FieldDateTime from '../common/FieldDateTime';
import FieldSelect from '../common/FieldSelect';
import FieldMultiSelect from '../common/FieldMultiSelect';
import FieldToggle from '../common/FieldToggle';
import FieldAddress from '../common/FieldAddress';

class SalesOrderCalculation extends React.Component {

  static Fields = [ 'build_area', 'carpet_area', 'base_price', 'flat_price', 'floor_rise', 'price', 'agreement_p', 
    'agreement_price', 'parking_charges', 'stamp_duty_p', 'stamp_duty', 'reg_charges_p', 'reg_charges', 'gst_p', 'gst',
    'legal_charges', 'development_charges', 'society_charges', 'mainten_charges', 'discount', 'commission', 'commission_p', 'total' ];

  getFields = (sales, fields, onValueChange, inValid) => {
    const keys = Object.keys(fields)
      .filter(key => SalesOrderCalculation.Fields.find(item => item === key))
      .sort((left, right) =>fields[left].field_order - fields[right].field_order );
    
    const list = [];
    for(let i = 0; i < keys.length; i++) {
      const type = fields[keys[i]].field_type;
      const key = keys[i];
      const field = fields[key];
      const value = sales[key];
      const innerData = { key: key, id: key, field: field, value: value,
        onValueChange: onValueChange, inValid: inValid };
      
      if(type === Const.Text) list.push(<FieldText {...innerData}/>);
      else if(type === Const.TextArea) list.push(<FieldTextArea { ...innerData } />);
      else if(type === Const.Number) list.push(<FieldNumber { ...innerData } />);
      else if(type === Const.Decimal) list.push(<FieldDecimal { ...innerData } />);
      else if(type.includes(Const.MultiSelect)) list.push(<FieldMultiSelect {...innerData}/>);
      else if(type.includes(Const.Select)) list.push(<FieldSelect { ...innerData } />);
      else if(type === Const.Date) list.push(<FieldDate { ...innerData } />);
      else if(type === Const.DateTime) list.push(<FieldDateTime { ...innerData } />);
      else if(type === Const.Toggle) list.push(<FieldToggle { ...innerData } />);
      else if(type === Const.Address) list.push(<FieldAddress { ...innerData } />);
    }
    return list;
  }
  
  render() {
    const sales = this.props.sales;
    const fields = this.props.model.fields;
    const onValueChange = this.props.onValueChange;
    const inValid = this.props.inValid;

    const list = this.getFields(sales, fields, onValueChange, inValid);
    if(list.length === 0) return null;
    return <>{list}</>;
  }
}

export default SalesOrderCalculation;